<template>
<div class="view">
    <ul class="img_list">
        <li v-for="item in imgList">
            <img :src="item.img">
            <span>{{item.styleTitle}}</span>
        </li>
    </ul>
   
    <div class="page">
        <el-pagination
            layout="prev, pager, next"
            :total="total" @current-change="pageChange"	>
        </el-pagination>
    </div>
</div>
</template>
<script>
    import {apiService, RESULT_CODE} from "@/api/ApiService.js"
    export default {
        name: 'CampusStyleView',
        data: function () {
            return {
                imgList: [],
                total: 0
            }
        },
        mounted() {
            // 查询校园风采图片
            apiService.findCampusStyleImg({pageNum: 1, pageSize: 6}).then(res => {
                this.imgList = res.data.list
                this.total = res.data.total
            })
        },
        methods: {
            pageChange(pageNum) {
                apiService.findCampusStyleImg({pageNum, pageSize: 6}).then(res => {
                this.imgList = res.data.list
                this.total = res.data.total
            })
            }
        }
    }
</script>
<style scoped>
    .view {
        padding: 0.25rem;
        background-color: #fff;
    }
    .img_list {
        height: 2.2rem;
        display: grid;
        grid-template-columns: repeat(3, 1.8rem);
        grid-template-rows: repeat(2, 1rem);
        place-content: space-evenly;
    }
    .img_list li {
        position: relative;
        overflow: hidden;
    }
    .img_list li>img {
        height: 100%;
        width: auto;
        min-width: 100%;
        position: absolute;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
    }
    .img_list li>span {
        position: absolute;
        bottom: 0;
        background: rgba(0,0,0,0.4);
        width: 100%;
        line-height: 0.2rem;
        color: #fff;
        text-indent: 1em;
    }
</style>


// WEBPACK FOOTER //
// src/pages/CampusStyleView.vue